import React from "react";
import PageHeader from "../../components/PageHeader";
import CmsPagesListComponent from "../../components/CmsPages/CmsPagesList";

class CmsPagesList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Cms Pages"
                            Breadcrumb={[
                                { name: "Cms Pages", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CmsPagesListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CmsPagesList;
